




































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';

export default Vue.extend({
    name: 'Share',

    data() {
        return {
            saving: false,
            email: '',
            message: 'I am sending you my profile from www.voicecasting.sk',
            shared: false,
            sharedEmail: '',
        };
    },

    methods: {
        submit() {
            if (this.errors.items.length || this.saving == true) return false;

            this.saving = true;
            this.$refs.submitBtn.setLoading();

            this.getActor
                .share(this.email, this.message)
                .then((response: any) => {
                    this.$refs.submitBtn.setSuccess('Success');
                    this.sharedEmail = this.email;
                    this.email = '';
                    // reset form errors
                    this.$validator.reset();
                    this.shared = true;

                    setTimeout(() => {
                        this.shared = false;
                    }, 5000);
                })
                .catch((err: any) => {
                    this.$env.log.error(err);
                    this.$bugsnag.notify(err);
                    this.$refs.submitBtn.setError('Failed');
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },

    computed: {
        ...mapGetters(['getActor']),
    },

    components: {
        PageHeader,
    },
});
